import { render, staticRenderFns } from "./PostCommentsBlock.vue?vue&type=template&id=4c922614"
import script from "./PostCommentsBlock.vue?vue&type=script&lang=js"
export * from "./PostCommentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports